// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table[data-v-55a1a365] {\n  width: 60vw;\n  margin: auto;\n}\n.note[data-v-55a1a365] {\n  margin: auto;\n  width: 60vw;\n}\n.text-left[data-v-55a1a365] {\n  display: flex;\n  text-align: left;\n}\n.text-left-note[data-v-55a1a365] {\n  text-align: left;\n}\n.manual-link[data-v-55a1a365] {\n  display: flex;\n  color: #0d6efd;\n  text-decoration: underline;\n  cursor: pointer;\n  cursor: hand;\n}\n", ""]);
// Exports
module.exports = exports;
